module.exports = __webpack_public_path__ + "img/1tnpup.54634607.png";